export default class Tenant {
  constructor(API) {
    this.api = API;
  }
  async createTenant(tenantObj) {
    const req = await this.api.newBaseRequest('POST');
    req.path = `/customer/${this.api.config.customerID}/tenant/new`;
    req.body = tenantObj;
    return await req.exec();
  }
  async updateTenant(tenantObj) {
    const req = await this.api.newBaseRequest('PUT');
    req.path = `/customer/${this.api.config.customerID}/tenant/${tenantObj.id}`;
    req.body = tenantObj;
    return await req.exec();
  }
  async deleteTenant(tenantID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = `/customer/${this.api.config.customerID}/tenant/${tenantID}`;
    return await req.exec();
  }
  async getTenant(tenantID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = `/customer/${this.api.config.customerID}/tenant/${tenantID}`;
    return await req.exec();
  }
  async getAllTenants(optCustomerID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = `/customer/${optCustomerID || this.api.config.customerID}/tenants`;
    return await req.exec();
  }
}
